import NewComponent from '@components/news';
import * as React from 'react';

export interface IPageNewProps {}

export default function PageNew(props: IPageNewProps) {
  return <NewComponent />;
}
